import { Company } from './Company.model';
import { BillingPaymentDetailVM } from './BillingPaymentDetailVM.model';
import { BillingPaymentProductDetailVM } from './BillingPaymentProductDetailVM.model';
import { BaseModel, StrictBaseModelPart, Property, hasUnionKeys } from '@dev-stream/utils';

export class BillingPaymentVM extends BaseModel<BillingPaymentVM> {
    protected BASE_TYPE = BillingPaymentVM;
    'Id'!: string | null;
    'Name'!: string | null;
    'Number'!: number | null;
    'TotalAmount'!: number | null;
    'InvoiceId'!: string | null;
    'TransactionId'!: number | null;
    'StorageId'!: string | null;
    @Property(() => Company)
    'Company'!: Company | null;
    @Property(() => Date)
    'PaymentDate'!: Date | null;
    'Status'!: number | null;
    @Property(() => Date)
    'CreatedOn'!: Date | null;
    @Property(() => BillingPaymentDetailVM)
    'BillingPaymentDetails'!: Array<BillingPaymentDetailVM | null>;
    @Property(() => BillingPaymentProductDetailVM)
    'BillingPaymentProductDetails'!: Array<BillingPaymentProductDetailVM | null>;

    public GetDefaultValue(): StrictBaseModelPart<BillingPaymentVM> {
        return {
            Id: null,
            Name: null,
            Number: null,
            TotalAmount: null,
            InvoiceId: null,
            TransactionId: null,
            StorageId: null,
            Company: null,
            PaymentDate: null,
            Status: null,
            CreatedOn: null,
            BillingPaymentDetails: [],
            BillingPaymentProductDetails: [],
        };
    }

    public static isBillingPaymentVM(o: any): o is BillingPaymentVM {
        return (
            o instanceof BillingPaymentVM ||
            hasUnionKeys(o, [
                'Id',
                'Name',
                'Number',
                'TotalAmount',
                'InvoiceId',
                'TransactionId',
                'StorageId',
                'Company',
                'PaymentDate',
                'Status',
                'CreatedOn',
                'BillingPaymentDetails',
                'BillingPaymentProductDetails',
            ])
        );
    }
}
